require('jquery-ui.1.11.1/ui/core');
require('jquery-ui.1.11.1/ui/widget');
require('jquery-ui.1.11.1/ui/mouse');
require('jquery-ui-touch-punch/jquery.ui.touch-punch.min');
require('jquery-ui.1.11.1/ui/draggable');
require('./files/description');
require('./files/add-to-cart-personalized');
require('./files/personalized-product');
require('./files/reviews');
require('./files/review-images');
require('./files/review-images-carousel');

require('../../css/web/add-to-cart.css');
require('../../css/web/reviews.css');
require('../../sass/web/reviews-images.scss');
require('../../css/web/tabs.css');
require('../../css/web/table-color.css');
require('../../css/web/services.css');
require('../../css/web/personalized-sticker.css');
require('../../sass/web/personalized_services.scss');
require('../../sass/web/review.scss');